/* Kräg product cards — quick add, color swatches, image swap */
(function(){
  function getData(card){
    if (card.__cardData !== undefined) return card.__cardData;
    var el = card.querySelector('[data-card-variants]');
    if (!el){ card.__cardData = null; return null; }
    try { card.__cardData = JSON.parse(el.textContent); }
    catch(e){ card.__cardData = null; }
    return card.__cardData;
  }

  function primaryImg(card){ return card.querySelector('[data-card-primary]'); }

  function setPrimary(card, url){
    var img = primaryImg(card);
    if (img && url) img.src = url;
  }

  function rememberOrig(card){
    var img = primaryImg(card);
    if (img && card.__origImg === undefined) card.__origImg = img.getAttribute('src');
  }

  function resolveVariant(data, color, size){
    var matches = data.variants.filter(function(v){
      var okColor = data.colorPos ? (color ? v.options[data.colorPos - 1] === color : true) : true;
      var okSize  = data.sizePos  ? v.options[data.sizePos - 1] === size : true;
      return okColor && okSize;
    });
    return matches.filter(function(v){ return v.available; })[0] || matches[0] || null;
  }

  // Marca tallas agotadas según el color seleccionado
  function refreshSizes(card){
    var data = getData(card);
    if (!data || !data.sizePos) return;
    var color = card.__selColor;
    card.querySelectorAll('[data-card-size]').forEach(function(btn){
      var size = btn.getAttribute('data-card-size');
      var v = resolveVariant(data, color, size);
      var ok = v && v.available;
      btn.disabled = !ok;
      btn.classList.toggle('is-soldout', !ok);
    });
  }

  function selectColor(card, swatch, swapImage){
    card.querySelectorAll('[data-card-color]').forEach(function(s){
      s.classList.toggle('is-active', s === swatch);
    });
    card.__selColor = swatch.getAttribute('data-card-color');
    var img = swatch.getAttribute('data-card-color-img');
    if (swapImage && img){
      setPrimary(card, img);
      card.classList.add('is-color-locked'); // congela el hover de la 2ª imagen
    }
    refreshSizes(card);
  }

  function add(variantId){
    if (window.KragCart && window.KragCart.addVariant){
      return window.KragCart.addVariant(variantId, 1).catch(function(err){ alert(err.message || 'No se pudo añadir'); });
    }
    // Fallback directo si cart.js no está disponible
    return fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin', body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function(){ window.location.href = '/cart'; });
  }

  // ---- Eventos ----
  document.addEventListener('click', function(e){
    var swatch = e.target.closest('[data-card-color]');
    if (swatch){
      e.preventDefault();
      selectColor(swatch.closest('[data-product-card]'), swatch, true);
      return;
    }

    var sizeBtn = e.target.closest('[data-card-size]');
    if (sizeBtn){
      e.preventDefault();
      if (sizeBtn.disabled) return;
      var card = sizeBtn.closest('[data-product-card]');
      var data = getData(card);
      if (!data) return;
      var v = resolveVariant(data, card.__selColor, sizeBtn.getAttribute('data-card-size'));
      if (v && v.available) add(v.id);
      return;
    }

    var addSel = e.target.closest('[data-card-add-selected]');
    if (addSel){
      e.preventDefault();
      var c = addSel.closest('[data-product-card]');
      var d = getData(c);
      if (!d) return;
      var chosen = resolveVariant(d, c.__selColor, null);
      if (chosen && chosen.available) add(chosen.id);
      return;
    }
  });

  // Preview de color al pasar por encima del swatch
  document.addEventListener('mouseover', function(e){
    var sw = e.target.closest('[data-card-color]');
    if (!sw) return;
    var card = sw.closest('[data-product-card]');
    rememberOrig(card);
    var img = sw.getAttribute('data-card-color-img');
    if (img) setPrimary(card, img);
  });
  document.addEventListener('mouseout', function(e){
    var sw = e.target.closest('[data-card-color]');
    if (!sw) return;
    var card = sw.closest('[data-product-card]');
    var active = card.querySelector('[data-card-color].is-active');
    var url = active && active.getAttribute('data-card-color-img');
    setPrimary(card, url || card.__origImg);
  });

  // Init: marca el primer color como activo y calcula disponibilidad de tallas
  function init(){
    document.querySelectorAll('[data-product-card]').forEach(function(card){
      rememberOrig(card);
      var firstColor = card.querySelector('[data-card-color]');
      if (firstColor){
        firstColor.classList.add('is-active');
        card.__selColor = firstColor.getAttribute('data-card-color');
      }
      refreshSizes(card);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
